import React, { forwardRef } from 'react';

import { DropdownMenuContent, DropdownMenuItem } from 'Storybook/peripheral/DropdownMenu';
import type { DropdownMenuContentProps } from 'Storybook/peripheral/DropdownMenu/components/DropdownMenuContent/DropdownMenuContent';
import type { DropdownMenuItemProps } from 'Storybook/peripheral/DropdownMenu/DropdownMenu.types';
import { Variant } from 'Types/variant';

export type DropdownMenuContentListProps = DropdownMenuContentProps & {
	list: DropdownMenuItemProps[];
};

const DropdownMenuContentList = forwardRef<HTMLDivElement, DropdownMenuContentListProps>(
	({ list, variant = Variant.PRIMARY, ...props }, forwardedRef) => (
		<DropdownMenuContent ref={forwardedRef} variant={variant} {...props}>
			{list.map((itemProps) => (
				<DropdownMenuItem key={itemProps.id} variant={variant} {...itemProps} />
			))}
		</DropdownMenuContent>
	),
);

export default DropdownMenuContentList;
